import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucEye: FC<IconType> = ({ iconColor = 'currentColor', ...svgProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 25 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M12.1133 5.66797C12.2422 5.66797 12.3711 5.625 12.5 5.625C14.7773 5.625 16.625 7.47266 16.625 9.75C16.625 12.0273 14.7773 13.875 12.5 13.875C10.1797 13.875 8.375 12.0273 8.375 9.75C8.375 9.66406 8.375 9.53516 8.375 9.40625C8.76172 9.62109 9.23438 9.75 9.75 9.75C11.2539 9.75 12.5 8.54688 12.5 7C12.5 6.52734 12.3281 6.05469 12.1133 5.66797ZM20.75 3.60547C22.7695 5.45312 24.1016 7.6875 24.7461 9.23438C24.875 9.57812 24.875 9.96484 24.7461 10.3086C24.1016 11.8125 22.7695 14.0469 20.75 15.9375C18.7305 17.8281 15.9375 19.375 12.5 19.375C9.01953 19.375 6.22656 17.8281 4.20703 15.9375C2.1875 14.0469 0.855469 11.8125 0.210938 10.3086C0.0820312 9.96484 0.0820312 9.57812 0.210938 9.23438C0.855469 7.6875 2.1875 5.45312 4.20703 3.60547C6.22656 1.71484 9.01953 0.125 12.5 0.125C15.9375 0.125 18.7305 1.71484 20.75 3.60547ZM12.5 3.5625C9.0625 3.5625 6.3125 6.35547 6.3125 9.75C6.3125 13.1875 9.0625 15.9375 12.5 15.9375C15.8945 15.9375 18.6875 13.1875 18.6875 9.75C18.6875 6.35547 15.8945 3.5625 12.5 3.5625Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucEye
